module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_8011.1125d172.png";